const enum FEATURE {
  ENABLE_BETA_WITHDRAWAL_BLOCKER = 'ENABLE_BETA_WITHDRAWAL_BLOCKER',
  ENABLE_CONTEST_DETAILS_JOIN_AND_DEPOSIT_BUTTONS = 'ENABLE_CONTEST_DETAILS_JOIN_AND_DEPOSIT_BUTTONS',
  ENABLE_LOCATION_CHECK_ON_LOGIN = 'ENABLE_LOCATION_CHECK_ON_LOGIN',
  USE_PAYPAL_INTERNAL_SIMULATOR = 'USE_PAYPAL_INTERNAL_SIMULATOR',
  ENABLE_NEW_KYC_FORM = 'ENABLE_NEW_KYC_FORM',
  SHOW_COMMISSIONER_ONBOARDING_CTA = 'SHOW_COMMISSIONER_ONBOARDING_CTA',
  ENABLE_COMMISSIONER_POSTS = 'ENABLE_COMMISSIONER_POSTS',
  ENABLE_DFS_GAME_UNITS = 'ENABLE_DFS_GAME_UNITS',
  ENABLE_CONTEST_DETAILS_BANNER_AND_AVATAR = 'ENABLE_CONTEST_DETAILS_BANNER_AND_AVATAR',
  SHOW_PUBLIC_PRIVATE_POSTS = 'SHOW_PUBLIC_PRIVATE_POSTS',
  CREATE_CONTEST_ENABLE_CUSTOM_FEE_AND_ENTRANTS = 'CREATE_CONTEST_ENABLE_CUSTOM_FEE_AND_ENTRANTS',
  SHOW_CONTEST_INVITE_CTA = 'SHOW_CONTEST_INVITE_CTA',
  SHOW_CONTEST_ITEM_THUMBNAIL = 'SHOW_CONTEST_ITEM_THUMBNAIL',
  SHOW_VIPP_AND_PAPER_CHECK = 'SHOW_VIPP_AND_PAPER_CHECK',
  ENABLE_POST_COMMENTS = 'ENABLE_POST_COMMENTS',
  JURISDICTION_ENABLE_INFO_CONTEST_DETAIL = 'JURISDICTION_ENABLE_INFO_CONTEST_DETAIL',
  JURISDICTION_ENABLE_INFO_LOBBY = 'JURISDICTION_ENABLE_INFO_LOBBY',
  ENABLE_REPORT_POST = 'ENABLE_REPORT_POST',
  ENABLE_HOME_PAGE = 'ENABLE_HOME_PAGE',
  ENABLE_HOME_PAGE_LIGHT_THEME = 'ENABLE_HOME_PAGE_LIGHT_THEME',
  KYC_PRIMARY_DEPOSIT_CTA = 'KYC_PRIMARY_DEPOSIT_CTA',
  CREATE_CONTEST_SHOW_DESCRIPTION_FIELD = 'CREATE_CONTEST_SHOW_DESCRIPTION_FIELD',
  SHOW_ASIDE_STATS_OWNERS = 'SHOW_ASIDE_STATS_OWNERS',
  SHOW_ASIDE_STATS_LAST_GAMES = 'SHOW_ASIDE_STATS_LAST_GAMES',
  PAYPAL_DEPOSIT_SUCCESS_DELAY = 'PAYPAL_DEPOSIT_SUCCESS_DELAY',
  ENABLE_ANONYMOUS_PICKS = 'ENABLE_ANONYMOUS_PICKS',
  ENABLE_COMMISSIONER_LIST_INTERCOM__CONTEST_DETAILS = 'ENABLE_COMMISSIONER_LIST_INTERCOM__CONTEST_DETAILS',
  CONFIG_PUSHER_ENABLED_ENDPOINTS = 'CONFIG_PUSHER_ENABLED_ENDPOINTS',
  ENABLE_POST_PICK_MODAL_FEATURED_CONTESTS = 'ENABLE_POST_PICK_MODAL_FEATURED_CONTESTS',
  DISABLED_PAYMENT_METHODS = 'DISABLED_PAYMENT_METHODS',
  ENABLE_SALARY_BASED_CONTESTS = 'ENABLE_SALARY_BASED_CONTESTS',
  ENABLE_NEW_GAMESHELL_FOR_CONTEST_TYPE = 'ENABLE_NEW_GAMESHELL_FOR_CONTEST_TYPE',
  SHOW_MAINTENANCE_BANNER = 'SHOW_MAINTENANCE_BANNER',
  SHOW_MAINTENANCE_SCREEN = 'SHOW_MAINTENANCE_SCREEN',
  ENABLE_SKIP_WELCOME_SCREEN = 'ENABLE_SKIP_WELCOME_SCREEN',
  ENABLE_VENMO = 'ENABLE_VENMO',
  CREATE_CONTEST_NFL_TIERS_OPTION_TAGS = 'CREATE_CONTEST_NFL_TIERS_OPTION_TAGS',
  CREATE_CONTEST_ALLOW_SELECT_INDIVIDUAL_GAMES = 'CREATE_CONTEST_ALLOW_SELECT_INDIVIDUAL_GAMES',
  CREATE_CONTEST_ALLOW_SET_PICK_DEADLINE = 'CREATE_CONTEST_ALLOW_SET_PICK_DEADLINE',
  CREATE_CONTEST_ALLOW_WEIGHTED_SCORING = 'CREATE_CONTEST_ALLOW_WEIGHTED_SCORING',
  CREATE_CONTEST_NFL_PICK_X_OPTION_TAGS = 'CREATE_CONTEST_NFL_PICK_X_OPTION_TAGS',
  ENABLE_CONTEST_COUNTDOWN_TIMER = 'ENABLE_CONTEST_COUNTDOWN_TIMER',
  CREATE_CONTEST_ALLOW_BEST_PICK = 'CREATE_CONTEST_ALLOW_BEST_PICK',
  ENABLE_CHAT = 'ENABLE_CHAT',
  ENABLE_DEBUG_MENU = 'ENABLE_DEBUG_MENU',
  ENABLE_DYNAMIC_CONTEST_LINK_PREVIEW = 'ENABLE_DYNAMIC_CONTEST_LINK_PREVIEW',
  ENABLE_DYNAMIC_CONTEST_LINK_PREVIEW_BASE64 = 'ENABLE_DYNAMIC_CONTEST_LINK_PREVIEW_BASE64',
  ENABLE_DYNAMIC_CONTEST_LINK_PREVIEW_DEADLINE = 'ENABLE_DYNAMIC_CONTEST_LINK_PREVIEW_DEADLINE',
  REFETCH_INTERVAL_FOR_TEAM_BASED_PICKSHEET = 'REFETCH_INTERVAL_FOR_TEAM_BASED_PICKSHEET',
  ALLOW_LIVE_GAMESHELL_POINTS = 'ALLOW_LIVE_GAMESHELL_POINTS',
  ENABLE_CANADA_IN_KYC_AND_BILLING_ADDRESS = 'ENABLE_CANADA_IN_KYC_AND_BILLING_ADDRESS',
  CREATE_CONTEST_ENABLE_CHAT = 'CREATE_CONTEST_ENABLE_CHAT',
  ENABLE_DFS_MULTI_SLATE = 'ENABLE_DFS_MULTI_SLATE',
  ENABLE_NEW_GAMESHELL_V2_FOR_CONTEST_TYPE = 'ENABLE_NEW_GAMESHELL_V2_FOR_CONTEST_TYPE',
  ENABLE_NEW_HEADER_2 = 'ENABLE_NEW_HEADER_2',
  ENABLE_APP_PROMPT = 'ENABLE_APP_PROMPT',
  USE_SKRILL_INTERNAL_SIMULATOR = 'USE_SKRILL_INTERNAL_SIMULATOR',
  GAMECENTER_UNSUPPORTED_TYPES_AND_FEATURES = 'GAMECENTER_UNSUPPORTED_TYPES_AND_FEATURES',
  DISABLE_PLAYER_BASED_CONTESTS = 'DISABLE_PLAYER_BASED_CONTESTS',
  ENABLE_SIGNUP_CONTEST_CARD = 'ENABLE_SIGNUP_CONTEST_CARD',
  ENABLE_PROPS = 'ENABLE_PROPS',
  ENABLE_CONTEST_INVITES_TAB = 'ENABLE_CONTEST_INVITES_TAB',
  ENABLE_EDIT_CONTEST = 'ENABLE_EDIT_CONTEST',
  ENABLE_EDIT_CONTEST_ADVANCED_SETTINGS = 'ENABLE_EDIT_CONTEST_ADVANCED_SETTINGS',
  ENABLE_RECAPTCHA = 'ENABLE_RECAPTCHA',
  ENABLE_REFER_A_FRIEND_V2 = 'ENABLE_REFER_A_FRIEND_V2',
  ENABLE_SURVIVOR_AVAILABILITY_PAGE = 'ENABLE_SURVIVOR_AVAILABILITY_PAGE',
  ENABLE_SURVIVOR_STATS_COMBOS = 'ENABLE_SURVIVOR_STATS_COMBOS',
  ENABLE_QUICK_PICKS_CANCEL_ENTRY = 'ENABLE_QUICK_PICKS_CANCEL_ENTRY',
  ENABLE_INVITES_MANAGER_FOLLOWERS = 'ENABLE_INVITES_MANAGER_FOLLOWERS',
  ENABLE_INVITES_MANAGER_GROUPS = 'ENABLE_INVITES_MANAGER_GROUPS',
  ENABLE_POPULAR_CHANNELS_ON_HOME = 'ENABLE_POPULAR_CHANNELS_ON_HOME',
  ENABLE_PLAY_WITH_PEOPLE_YOU_FOLLOW = 'ENABLE_PLAY_WITH_PEOPLE_YOU_FOLLOW',
  ENABLE_INVITES_MANAGER_RYP = 'ENABLE_INVITES_MANAGER_RYP',
  ENABLE_INVITES_MANAGER_OFP = 'ENABLE_INVITES_MANAGER_OFP',
  ENABLE_SLIP_DEBUG_BLOCK = 'ENABLE_SLIP_DEBUG_BLOCK',
  ENABLE_INVITES_MANAGER_ALL = 'ENABLE_INVITES_MANAGER_ALL',
  // Payments
  ENABLE_AEROPAY = 'ENABLE_AEROPAY',
  ENABLE_DEPOSIT_MATCH_BONUS = 'ENABLE_DEPOSIT_MATCH_BONUS',
  ENABLE_ENTRIES_ENTRY_FEE_FILTER = 'ENABLE_ENTRIES_ENTRY_FEE_FILTER',
  HIDE_MY_CONTESTS_ELIMINATED_TOGGLE = 'HIDE_MY_CONTESTS_ELIMINATED_TOGGLE',
  ENABLE_HOME_QP = 'ENABLE_HOME_QP',
  ENABLE_HOME_NOTIFICATION_WIDGETS = 'ENABLE_HOME_NOTIFICATION_WIDGETS',
  HOME_SECTIONS_ORDER = 'HOME_SECTIONS_ORDER',
  ENABLE_SLIP_COPY_ID = 'ENABLE_SLIP_COPY_ID',
  ENABLE_EDIT_CONTEST_SIZE = 'ENABLE_EDIT_CONTEST_SIZE',
  ENABLE_EDIT_SCHEDULE = 'ENABLE_EDIT_SCHEDULE',
  ENABLE_EDIT_SEGMENTS = 'ENABLE_EDIT_SEGMENTS',
  ENABLE_INVITES_DOWNLOAD = 'ENABLE_INVITES_DOWNLOAD',
  ENABLE_INVITES_REVIEW_MODAL = 'ENABLE_INVITES_REVIEW_MODAL',
  ENABLE_ENTRANT_MANAGER = 'ENABLE_ENTRANT_MANAGER',
  ENABLE_POOL_MEMBERS_DOWNLOAD = 'ENABLE_POOL_MEMBERS_DOWNLOAD',
  ENABLE_PLAYERS_TAB_TABLE_VIEW = 'ENABLE_PLAYERS_TAB_TABLE_VIEW',
  ENABLE_INVITES_MANAGER_DRILLDOWN = 'ENABLE_INVITES_MANAGER_DRILLDOWN',
  ENABLE_WELCOME_MODALS = 'ENABLE_WELCOME_MODALS',
  // Used for Commissioner Filters
  COMMISSIONER_FILTER_SORT = 'COMMISSIONER_FILTER_SORT',
  // Used for contest lobby and entries page filter
  CONFIG_LOBBY_FILTERS = 'CONFIG_LOBBY_FILTERS',
  ENABLE_MANAGE_CONTEST = 'ENABLE_MANAGE_CONTEST',
  ENABLE_INVITES_MANAGER_V3 = 'ENABLE_INVITES_MANAGER_V3',
  SHOW_INVITES_MANAGER_SEARCH = 'SHOW_INVITES_MANAGER_SEARCH',
  ENABLE_POST_PICK_QP_PROMOTION = 'ENABLE_POST_PICK_QP_PROMOTION',
  ENABLE_PRESELECTED_PROPS = 'ENABLE_PRESELECTED_PROPS',
  ENABLE_ENTRANTS_MANAGER_RENAME_ENTRY = 'ENABLE_ENTRANTS_MANAGER_RENAME_ENTRY',
  SHOW_MY_CONTESTS_CALLOUT = 'SHOW_MY_CONTESTS_CALLOUT',
  ENABLE_GAMECENTER_RAF_CALLOUT = 'ENABLE_GAMECENTER_RAF_CALLOUT',
  ENABLE_ENTRANTS_MANAGER_REVIVALS = 'ENABLE_ENTRANTS_MANAGER_REVIVALS',
  ENABLE_ENTRANTS_MANAGER_ACTIVITY = 'ENABLE_ENTRANTS_MANAGER_ACTIVITY',
  ENABLE_MANAGE_ENTRIES_PICKS = 'ENABLE_MANAGE_ENTRIES_PICKS',
  ENABLE_BULK_CSV_PICK_UPLOAD = 'ENABLE_BULK_CSV_PICK_UPLOAD',
  ENABLE_UNIFIED_CAC_FLOW = 'ENABLE_UNIFIED_CAC_FLOW',
  BLOCK_INVITES_MANAGER_ACCESS = 'BLOCK_INVITES_MANAGER_ACCESS',
  ENABLE_CHAT_WEB = 'ENABLE_CHAT_WEB',
  ENABLE_PROVE_KYC_WEB = 'ENABLE_PROVE_KYC_WEB',
  ENABLE_PREDICTION_MARKETS = 'ENABLE_PREDICTION_MARKETS',
  ENABLE_HOME_PREDICTION_MARKETS_WIDGET = 'ENABLE_HOME_PREDICTION_MARKETS_WIDGET',
  ENABLE_PREDICTION_MARKETS_SIX_BOX = 'ENABLE_PREDICTION_MARKETS_SIX_BOX',
  ENABLE_PREDICTION_MARKETS_PRICE_TOLERANCE = 'ENABLE_PREDICTION_MARKETS_PRICE_TOLERANCE',
  ENABLE_PROMO_CODES = 'ENABLE_PROMO_CODES',
  ENABLE_WHALERS_CLUB = 'ENABLE_WHALERS_CLUB',
  ENABLE_MISSIONS = 'ENABLE_MISSIONS',
  ENABLE_EMAIL_INVITES = 'ENABLE_EMAIL_INVITES',
  ENABLE_NATIVE_INVITES_RYP_OFP = 'ENABLE_NATIVE_INVITES_RYP_OFP',
  ENABLE_CONTEST_DETAIL_MARKETPLACE_PROMO = 'ENABLE_CONTEST_DETAIL_MARKETPLACE_PROMO',
  MARKETPLACE_LISTING_PRICE_CAP = 'MARKETPLACE_LISTING_PRICE_CAP',
  ENABLE_MARKETPLACE_OFFER_SETTINGS = 'ENABLE_MARKETPLACE_OFFER_SETTINGS',
  ENABLE_STANDINGS_CSV_EXPORT = 'ENABLE_STANDINGS_CSV_EXPORT',
  SHOW_SAVED_CREDIT_CARDS_ON_DEPOSIT = 'SHOW_SAVED_CREDIT_CARDS_ON_DEPOSIT',
  ENABLE_CONDENSED_CAROUSELS_WEB = 'ENABLE_CONDENSED_CAROUSELS_WEB',
  MIXPANEL_TEST_GATE = 'MIXPANEL_TEST_GATE',
  MIXPANEL_TEST_VARIANTS = 'MIXPANEL_TEST_VARIANTS',
  MIXPANEL_TEST_EXPERIMENT = 'MIXPANEL_TEST_EXPERIMENT',
}

export { FEATURE };
